import { render, staticRenderFns } from "./goTo.vue?vue&type=template&id=57ccd0ec&scoped=true"
import script from "./goTo.vue?vue&type=script&lang=js"
export * from "./goTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ccd0ec",
  null
  
)

export default component.exports